import api from './api';
import { API_ENDPOINTS, USE_MOCK_DATA } from '../constants/config';
import { ROLES } from '../constants/roles';

class ManagerService {
  async getAllManagers() {
    try {
      const response = await api.get(API_ENDPOINTS.USERS_BY_ROLE(ROLES.MANAGER));
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Error fetching managers:', error);
      return { success: false, error: error.message };
    }
  }

  async createManager(managerData) {
    try {
      const response = await api.post(API_ENDPOINTS.USERS, { ...managerData, role: ROLES.MANAGER });
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Error creating manager:', error);
      return { success: false, error: error.response?.data?.detail || error.message };
    }
  }

  async updateManager(managerId, managerData) {
    try {
      const response = await api.put(API_ENDPOINTS.USER_DETAILS(managerId), managerData);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Error updating manager:', error);
      return { success: false, error: error.response?.data?.detail || error.message };
    }
  }

  async deleteManager(managerId) {
    try {
      await api.delete(API_ENDPOINTS.USER_DETAILS(managerId));
      return { success: true };
    } catch (error) {
      console.error('Error deleting manager:', error);
      return { success: false, error: error.response?.data?.detail || error.message };
    }
  }
  
  async updateSupervisor(userId, supervisorId) {
    try {
      const response = await api.put(API_ENDPOINTS.ENGINEER_UPDATE_TL(userId), { team_lead_id: supervisorId });
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Error updating supervisor:', error);
      return { success: false, error: error.response?.data?.detail || error.message };
    }
  }
}

export default new ManagerService();
